import { ReactNode } from "react";
import mypic from "./mypic.jpg";
import resume from "../Images/Sachin_Kesarwani_Resume.pdf";
import {
  Box,
  Flex,
  Avatar,
  HStack,
  Text,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  Heading,
} from "@chakra-ui/react";
import {BiArrowToBottom} from "react-icons/bi";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import {HashLink as Link} from "react-router-hash-link"
import { redirect } from "../utils";
//import { Link } from "react-scroll";

let data = [
  { path: "#home", title: "Home", class: "nav-link home" },
  { path: "#about", title: "About", class: "nav-link about" },
  { path: "#skills", title: "Skill", class: "nav-link skills" },
  { path: "#projects", title: "Project", class: "nav-link projects" },
  { path: "#contact", title: "Contact", class: "nav-link contact" },

];

// {path:"#resume",title:"Resume",class:"nav-link resume"}
const NavLink = ({ children }) => (
  <Link
    px={2}
    py={1}
    rounded={"md"}
    _hover={{
      textDecoration: "none",
      bg: useColorModeValue("gray.200", "gray.700"),
    }}
    href={"#"}
  >
    {children}
  </Link>
);

export default function Simple() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // function redirect() {
  //   window.open(
  //     "https://drive.google.com/file/d/1zztPdp7ZZE-dTh7X4-V7oOVyuHH7TVXH/view",
  //     "_blank",
  //     "noreferrer"
  //   );
  // }
  return (
    <>
      <Box
        id="nav-menu"
        // bg={useColorModeValue("blue.100", "blue.900")}
        bg={"blackAlpha.900"}
        position={"fixed"}
        w="100%"
        px={4}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            gr
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <Heading color={"white"}>SK</Heading>
            <HStack
              as={"nav"}
              spacing={4}
              display={{ base: "none", md: "flex" }}
            >
              {data.map((e) => (
              
                  <Link
                    spy={true}
                    smooth={true}
                    offset={50}
                    duration={500}
                    to={e.path}
                    className={e.class}
                  >
                      <Button boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)" bg="green.400" color="white" _hover={{ bg: "green.400" }}>
                    {e.title}
                    </Button>
                  </Link>
               
              ))}
              <Link
              className="nav-link resume"
                // href={resume}
              to={resume}
                id="resume-link-1"
                // className="nav-link resume"
                // download
              
                // id="resume-button-1"
                target="_blank"
                download="Sachin-Kesarwani.pdf"
              >
                <Button

                 onClick={redirect}
                  bg="green.400"
                  color="white"
                  boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
                  _hover={{ bg: "green.400" }}
                  id="resume-button-1"
                >
                  Resume <BiArrowToBottom fontSize={"20px"} color={"green.600"} />
                </Button>
              </Link>
            </HStack>
          </HStack>
          <Flex alignItems={"center"}>
            <Menu>
              <MenuButton
                as={Button}
                rounded={"full"}
                variant={"link"}
                cursor={"pointer"}
                minW={0}
              >
                <Avatar size={"sm"} src={mypic} />
              </MenuButton>
              {/* <MenuList>
                <MenuItem>Link 1</MenuItem>
                <MenuItem>Link 2</MenuItem>
                <MenuDivider />
                <MenuItem>Link 3</MenuItem>
              </MenuList> */}
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              <Box display={"grid"} rowGap={"18px"} gridTemplateColumns={"repeat(3,1fr)"}>
              {data.map((e) => (
                <Link
                  spy={true}
                   style={{color:"green"}}
                  smooth={true}
                  offset={50}
                  duration={500}
                  w="40px"
                  to={e.path}
                  className={e.class}
                >
                <b> {e.title}</b> 
                </Link>
              ))}
              </Box>
            
              <Link
              className="nav-link resume"
                // href={resume}
                to={resume}
                // to={"#resume"}
                id="resume-link-1"
               
             
                download="Sachin-Kesarwani.pdf"
              >
                <Button
                style={{ position: "static", marginTop: "20px" }}
                onClick={redirect}
                 bg="black"
                   _hover={{ bg:"#2e9b56",color:"white"}}
                   color="#2e9b56"
                border={"2px solid #2e9b56"}
                  id="resume-button-1"
                >
                  Resume <BiArrowToBottom fontSize={"20px"} color={"green.600"} />
                </Button>
              </Link>
            </Stack>
          </Box>
        ) : null}
      </Box>

      {/* <Box p={4}>Main Content Here</Box> */}
    </>
  );
}
